import React from "react";
import AnimatedPage from "../AnimatedPage";

const Carto = () => {
  return (
    <AnimatedPage>
      <div className="iframe__ctn">
        <iframe
          title="Site Carto Interactive"
          src="https://plan-tan.fr/"
        ></iframe>
      </div>
    </AnimatedPage>
  );
};

export default Carto;
